export default "__VITE_ASSET__GP9dEB4R__"